import { render, staticRenderFns } from "./nowwaWareDetailTable.vue?vue&type=template&id=6ed01f89&scoped=true&"
import script from "./nowwaWareDetailTable.vue?vue&type=script&lang=js&"
export * from "./nowwaWareDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./nowwaWareDetailTable.vue?vue&type=style&index=0&id=6ed01f89&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed01f89",
  null
  
)

export default component.exports